import { render } from "./Demo.vue?vue&type=template&id=20ff09f0&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=20ff09f0&lang=less&scoped=true"

import exportComponent from "/Users/qilei/Desktop/other/dingcan4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ff09f0"]])

export default __exports__